import { api, getList } from "./api";
import type {
  Conteneur,
  ConteneurPayload,
  SuiviTemperatureConteneur,
  SuiviTemperatureConteneurPayload,
} from "../types/conteneur";
import type { HistoriqueEtatConteneur } from "../types/historiqueetatconteneur";

// -------------------------
// Conteneurs
// -------------------------

// Récupérer tous les conteneurs
export async function getConteneurs(): Promise<Conteneur[]> {
  return getList<Conteneur>("/conteneurs/");
}

// Récupérer un conteneur par ID
export async function getConteneur(id: string): Promise<Conteneur> {
  const res = await api.get(`/conteneurs/${id}/`);
  return res.data;
}

// Créer un conteneur
export async function createConteneur(payload: ConteneurPayload): Promise<Conteneur> {
  const res = await api.post("/conteneurs/", payload);
  return res.data;
}

// Mettre à jour un conteneur
export async function updateConteneur(id: string, payload: Partial<ConteneurPayload>): Promise<Conteneur> {
  const res = await api.put(`/conteneurs/${id}/`, payload);
  return res.data;
}

// Supprimer un conteneur
export async function deleteConteneur(id: string): Promise<void> {
  await api.delete(`/conteneurs/${id}/`);
}

// ✅ Récupérer l’historique des états pour un conteneur
export async function getHistoriqueConteneur(conteneurId: string): Promise<HistoriqueEtatConteneur[]> {
  return getList<HistoriqueEtatConteneur>(`/conteneurs/${conteneurId}/historiques-etats/`);
}

// -------------------------
// Suivi Températures Conteneurs
// -------------------------

// Récupérer tous les suivis de température
export async function getSuiviConteneurs(): Promise<SuiviTemperatureConteneur[]> {
  return getList<SuiviTemperatureConteneur>("/suivi-conteneurs/");
}

// Récupérer un suivi par ID
export async function getSuiviConteneur(id: string): Promise<SuiviTemperatureConteneur> {
  const res = await api.get(`/suivi-conteneurs/${id}/`);
  return res.data;
}

// Créer un suivi de température
export async function createSuiviConteneur(payload: SuiviTemperatureConteneurPayload): Promise<SuiviTemperatureConteneur> {
  const res = await api.post("/suivi-conteneurs/", payload);
  return res.data;
}

// Mettre à jour un suivi de température
export async function updateSuiviConteneur(id: string, payload: Partial<SuiviTemperatureConteneurPayload>): Promise<SuiviTemperatureConteneur> {
  const res = await api.put(`/suivi-conteneurs/${id}/`, payload);
  return res.data;
}

// Supprimer un suivi de température
export async function deleteSuiviConteneur(id: string): Promise<void> {
  await api.delete(`/suivi-conteneurs/${id}/`);
}
